<template>
  <div id="member-payroll">
     <div class="select-month">
      <span class='title'>Month</span>
      <el-date-picker v-model="month"
                      type="month"
                      placeholder="select month"
                      value-format="yyyy-MM">
      </el-date-picker>
      <button class="search-btn"
              @click="getPayroll()">Search</button>
    </div>
    <ul class="table" v-if="isData">
      <li>
        <div>Name</div>
        <div>ID</div>
        <div>Bank charges</div>
        <div>Total</div>
      </li>
      <li v-for="item in list" :key="item.teaNo">
        <div>{{item.teacherName}}</div>
        <div>{{item.teaNo}}</div>
        <div>{{item.bankCharge}}</div>
        <div>{{item.total}}</div>
      </li>
    </ul>
  </div>
</template>
<script>
import './index.less';
import timeTools from '@/utils/timeTools';
export default {
data(){
  return{
    month:timeTools.getPreMonth(new Date()).slice(0, 7), //默认上一个月份,
    list:[],
    isData:false,
  };
},
methods:{
  async getPayroll(){
    const res=await this.$api.getMemberPayroll(this.month);
    if(res.data.resultData.length===0){
      this.isData=false;
    }else{
      this.isData=true;
      this.list=res.data.resultData;
    }
  }
}
};
</script>



// WEBPACK FOOTER //
// src/global-components/MemberPayroll/index.vue